export default __webpack_public_path__ + "static/media/Mc001-Picture3.663023c9.png";